import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { SpecialOfferFirestoreResponse, SpecialOfferPaginationData } from '../types';
import { EVENTS_PER_PAGE } from '../variables';
import { fetchPaginatedCollection } from './utils';

const PAGE_SIZE = EVENTS_PER_PAGE;

export const useGetSpecialOfferFromFirestore = (
  page: number,
  id: string,
  options?: UseQueryOptions<SpecialOfferPaginationData, FirebaseError, SpecialOfferPaginationData>,
): UseQueryResult<SpecialOfferPaginationData, FirebaseError> => useQuery<SpecialOfferPaginationData,
    FirebaseError,
    SpecialOfferPaginationData
>({
  queryKey: [`hotels/${id}/specialOffer`, page, PAGE_SIZE] as const,
  queryFn: async () : Promise<SpecialOfferPaginationData> => {
    const { data, totalPages } = await fetchPaginatedCollection<SpecialOfferFirestoreResponse>(
      `hotels/${id}/specialOffer`,
      page,
      PAGE_SIZE,
      'createdAt',
    );
    const mappedData = data.map((item) => ({
      id: item.id,
      title: item.title,
      cover: item.cover,
      createdAt: item.createdAt,
      file: item.file,
      end_date: item.end_date,
      label: item.label,
      order: item.order,
    }));
    return { data: mappedData, totalPages };
  },
  retry: 0,
  ...options,
});
